import React, { useState } from "react";
import { TextMessage, ImageMetadata } from "../../../types/chat";
import MediaPreviewModal, { MediaItem } from "../../MediaPreviewModal";
import FormattedText from "../FormattedText";
import styles from "./ImageMessage.module.scss";

interface ImageMessageProps {
  message: TextMessage;
  metadata: ImageMetadata;
  isOwnMessage?: boolean;
}

const ImageMessage: React.FC<ImageMessageProps> = ({ message, metadata, isOwnMessage }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const handleImageLoad = () => setImageLoaded(true);
  const handleImageError = () => setImageError(true);

  const handleImageClick = () => {
    if (!imageError) {
      setShowPreview(true);
    }
  };

  const previewItems: MediaItem[] = [
    {
      type: "image",
      url: metadata.attachmentUrl || metadata.thumbnailUrl || "",
      thumbnailUrl: metadata.thumbnailUrl,
      name: metadata.name,
      caption: message.content?.message !== metadata.attachmentUrl ? message.content?.message : undefined,
    },
  ];

  if (imageError) {
    return (
      <div className={styles.imageError}>
        <span>❌ Không thể tải hình ảnh</span>
      </div>
    );
  }

  return (
    <>
      <div className={styles.imageMessage}>
        <div className={styles.imageContainer} onClick={handleImageClick} style={{ cursor: "pointer" }}>
          {!imageLoaded && <div className={styles.imagePlaceholder}>Đang tải...</div>}
          <img
            src={metadata.thumbnailUrl || metadata.attachmentUrl}
            alt={metadata.name}
            className={styles.image}
            onLoad={handleImageLoad}
            onError={handleImageError}
            style={{ display: imageLoaded ? "block" : "none" }}
          />
          {/* HD Badge */}
          <div className={styles.hdBadge}>HD</div>
        </div>

        {/* Display text content if exists */}
        {message.content?.message && message.content.message !== metadata.attachmentUrl && (
          <div className={`${styles.imageCaption} ${isOwnMessage ? styles.ownMessage : styles.otherMessage}`}>
            <FormattedText text={message.content.message} />
          </div>
        )}
      </div>

      <MediaPreviewModal isOpen={showPreview} onClose={() => setShowPreview(false)} items={previewItems} />
    </>
  );
};

export default ImageMessage;
